import {
  EMBED_FAILURE_REASONS,
  type EmbedFailure,
} from './shared-responder-v2-core-embed-port.types';

export function resolveEmbedFailure(input: {
  isAborted: boolean;
  isEmbeddable: boolean;
  hasCreateError: boolean;
  message: string | null;
}): EmbedFailure | null {
  const reason = resolveEmbedFailureReason(input);

  if (reason === null) {
    return null;
  }

  return { reason, message: input.message };
}

function resolveEmbedFailureReason(input: {
  isAborted: boolean;
  isEmbeddable: boolean;
  hasCreateError: boolean;
}): EmbedFailure['reason'] | null {
  if (input.isAborted) return EMBED_FAILURE_REASONS.Aborted;
  if (!input.isEmbeddable) return EMBED_FAILURE_REASONS.NotEmbeddable;
  if (input.hasCreateError) return EMBED_FAILURE_REASONS.CreateFailed;

  return null;
}
